<template>
  <b-row class="match-height">
    <b-col
lg="8"
offset="2"
> <b-card
    title="Stock Opname Detail"
  >
      <b-row>
        <b-col cols="12">
          <b-button
            type="button"
            variant="primary"
            class="mr-1"
            @click="previous()"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="16"
              class="align-middle"
            />
            Back
          </b-button>
          <b-button
            v-if="canVoid"
            type="button"
            variant="danger"
            class="mr-1"
            @click="openVoidModal()"
          >
            <feather-icon
              icon="XCircleIcon"
              size="16"
              class="align-middle"
            />
            Reject / Void
          </b-button>
          <!-- FA-only: resolve a pending void request submitted by Finance -->
          <template v-if="canResolveVoid">
            <b-button
              type="button"
              variant="danger"
              class="mr-1"
              @click="resolveVoid(true)"
            >
              <feather-icon
                icon="CheckIcon"
                size="16"
                class="align-middle"
              />
              Confirm Void
            </b-button>
            <b-button
              type="button"
              variant="outline-secondary"
              class="mr-1"
              @click="resolveVoid(false)"
            >
              Reject Request
            </b-button>
          </template>
          <b-alert
            v-if="stockOpnameIsDeleted"
            show
            variant="danger"
            class="p-1 mt-1"
          >
            This Stock Opname has been Voided/Rejected.
            <span v-if="stockOpnameDeletedReason">Reason: {{ stockOpnameDeletedReason }}</span>
          </b-alert>
          <b-alert
            v-if="stockOpnameVoidStatus === 'pending'"
            show
            variant="warning"
            class="p-1 mt-1"
          >
            A void request is pending FA confirmation.
            <span v-if="stockOpnameVoidReason">Reason: {{ stockOpnameVoidReason }}</span>
          </b-alert>
          <b-alert
            v-if="stockOpnameVoidStatus === 'rejected'"
            show
            variant="secondary"
            class="p-1 mt-1"
          >
            The last void request was rejected by FA.
            <span v-if="stockOpnameVoidResolutionReason">Reason: {{ stockOpnameVoidResolutionReason }}</span>
          </b-alert>
          <div class="devider" />
          </b-col>
      <b-col cols="12">
          <b-form-group
            label="Date *"
            label-cols-md="12"
          >
            <b-form-input
              id="stockOpnameDate"
              v-model="stockOpnameDate"
              readonly="readonly"
            />
          </b-form-group>
        <b-form-group>
          <label for="no_invoice">Description *</label>
            <b-form-input
              id="description"
              v-model="stockOpnameDescription"
              readonly="readonly"
            />
        </b-form-group>
        <b-form-group>
          <label for="no_invoice">Hour *</label>
            <b-form-input
              id="hour"
              v-model="stockOpnameHour"
              readonly="readonly"
            />
        </b-form-group>
      <b-form-group>
        <label for="no_invoice">Status :</label>
        <vue-horizontal-timeline :items="statusItems" />
      </b-form-group>
      <b-form-group>
        <label for="no_invoice">Items :</label>
      </b-form-group>
      <b-form-group>
        <br>
         <div>
          <b-row>
            <b-col
cols="4"
class="text-center font-weight-bold"
>
              Item name
            </b-col>
            <b-col
cols="2"
class="text-center font-weight-bold"
>
              Curent Stock
            </b-col>
            <b-col
cols="2"
class="text-center font-weight-bold"
>
              QTY Opname
            </b-col>
            <b-col
cols="2"
class="text-center font-weight-bold"
>
              Difference
            </b-col>
            <b-col
cols="2"
class="text-center font-weight-bold"
>
              Shelf
            </b-col>
            </b-row>
         <p />
          <b-row
v-for="(item) in items"
:key="item.stock_opname_detail_item_id"
>
          <br>
            <b-col
cols="4"
class="text-center"
>
                <b-list-group>
                  <b-list-group-item href="#">
{{ item.item.item_name }} ({{ item.item.item_code }})
</b-list-group-item>
                </b-list-group>
              </b-col>
            <b-col
cols="2"
class="text-center"
>
            <b-form-input
              v-model="item.stock_opname_detail_item_current_stock"
              class="text-center"
              readonly
              />
            </b-col>
            <b-col
cols="2"
class="text-center"
>
            <b-form-input
              v-model="item.stock_opname_detail_item_qty"
              class="text-center"
              readonly
              />
            </b-col>
            <b-col
cols="2"
class="text-center"
>
            <b-form-input
              v-model="item.stock_opname_detail_item_difference"
              class="text-center"
              readonly
              />
            </b-col>
            <b-col
cols="2"
class="text-center"
>
            <b-form-input
              v-model="item.stock_opname_detail_location"
              class="text-center"
              readonly
              />
            </b-col>
            <b-col cols="12">
              <br>
            </b-col>
            </b-row>
          </div>
      </b-form-group>
        </b-col>
      </b-row>
  </b-card>
    </b-col>
    <!-- Reject / Void modal -->
    <b-modal
      id="modal-void-stock-opname"
      v-model="modalVoidShow"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Reject / Void this Stock Opname"
    >
      <b-form @submit.prevent="voidStockOpname()">
        <div class="text-center">
          <p>Are you sure you want to Reject/Void this Stock Opname? This action is recorded and visible to Finance - it cannot be undone.</p>
          <b-form-group
            label="Reason *"
            label-for="void_reason"
          >
            <b-form-input
              id="void_reason"
              v-model="VoidReason"
              placeholder="Enter the reason"
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="danger"
            class="mr-2"
            :disabled="!VoidReason || submitButtonDisabled"
          >
            Yes, Void
          </b-button>
          <b-button
            variant="secondary"
            @click="modalVoidShow = false"
          >
            No
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BListGroup, BListGroupItem, BModal, BAlert,
  } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import { VueHorizontalTimeline } from "vue-horizontal-timeline"
import { ref } from '@vue/composition-api'
import apiEndpoints from '@/constants/apiEndpoints'

const VersionCheck = ''
const items = []
const chosenItem = ref(3)
const chosens = []
const statusItems = []
const supplier = ''
const shipmenBy = ''
const deliveryAddress = ''
const stockOpnameSchedule = ''
const billingAddress = ''
const termOfPayment = ''
const paymentType = ''
const stockOpnameIsConfirmed = false
const stockOpnameIsReceived = false
const userRole = ''
const stockOpnameId = ''
const stockOpnameNumber = ''
const stockOpnameIsDeleted = false
const stockOpnameDeletedReason = ''
const stockOpnameIsConfirmedByAdministrator = false
const stockOpnameVoidStatus = null
const stockOpnameVoidReason = ''
const stockOpnameVoidResolutionReason = ''
const modalVoidShow = false
const VoidReason = ''
const submitButtonDisabled = false
export default {
  components: {
    VueHorizontalTimeline,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BModal,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
    stockOpnameIsConfirmed,
    stockOpnameIsReceived,
    paymentType,
    statusItems,
    VersionCheck,
    items,
    chosenItem,
    chosens,
    supplier,
    shipmenBy,
    deliveryAddress,
    stockOpnameSchedule,
    billingAddress,
    termOfPayment,
    userRole,
    stockOpnameId,
    stockOpnameNumber,
    stockOpnameIsDeleted,
    stockOpnameDeletedReason,
    stockOpnameIsConfirmedByAdministrator,
    stockOpnameVoidStatus,
    stockOpnameVoidReason,
    stockOpnameVoidResolutionReason,
    modalVoidShow,
    VoidReason,
    submitButtonDisabled,
    }
  },
  computed: {
    // Void is only offered while the opname hasn't already been finished by the
    // administrator, not already voided, and no void request is already pending.
    // Kept to 'finance'/'administrator' roles - client asked that this not be
    // something any random role can trigger.
    // NOTE: administrator voids directly (server confirms this), finance's click here
    // only ever submits a pending request - the actual "no direct void" gate is
    // enforced server-side in voidAction, this is just matching UX.
    canVoid() {
      return (this.userRole === 'finance' || this.userRole === 'administrator')
        && !this.stockOpnameIsConfirmedByAdministrator
        && !this.stockOpnameIsDeleted
        && this.stockOpnameVoidStatus !== 'pending'
    },
    // FA-only: shown when there's a pending void request from Finance waiting on them.
    canResolveVoid() {
      return this.userRole === 'fa-coal-manager' && this.stockOpnameVoidStatus === 'pending'
    },
  },
  mounted() {
      this.userRole = this.$cookies.get('UserRole')
      this.getDetail()
  },
  methods: {
  getDetail() {
    const userToken = this.$cookies.get('userToken')
const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${userToken}`,
}
    // Stock Opname id now comes from the route (tab-safe: refresh/second tab
    // both resolve to the correct opname from the URL, not a shared
    // localStorage key that a different tab/page could have overwritten).
    const { id } = this.$route.params

    if (!id) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Fetching Data failed',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text: 'No Stock Opname id in the URL',
        },
      })
      return
    }

    this.modalDetailShow = true

    axios
    .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_STOCK_OPNAMES}?id=${id}`, { headers })
    .then(headerResponse => {
      if (headerResponse.data.success !== true || !headerResponse.data.data || headerResponse.data.data.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fetching Data failed',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return
      }

      const item = headerResponse.data.data[0]

      this.stockOpnameBranch = `${item.branch.branch_name}  (${item.branch.branch_code})`
      this.stockOpnameDate = this.dateSimple(item.stock_opname_date)
      this.stockOpnameHour = item.stock_opname_hour
      this.stockOpnameDescription = item.stock_opname_description
      this.stockOpnameIsConfirmed = item.stock_opname_is_confirmed_by_lab_manager === true ? true : false
      this.stockOpnameType = item.stock_opname_type
      this.stockOpnameNotes = item.stock_opname_notes
      this.stockOpnameNumber = item.stock_opname_number
      this.stockOpnameIsDeleted = item.stock_opname_is_deleted === true
      this.stockOpnameDeletedReason = item.stock_opname_deleted_reason
      this.stockOpnameIsConfirmedByAdministrator = item.stock_opname_is_confirmed_by_administrator === true
      this.stockOpnameVoidStatus = item.stock_opname_void_status || null
      this.stockOpnameVoidReason = item.stock_opname_void_reason
      this.stockOpnameVoidResolutionReason = item.stock_opname_void_resolution_reason
      this.stockOpnameId = item.stock_opname_id
      const obj1 = {
        title: 'Created',
        content: `Stock Opname Has been Created at ${this.dateSimple(item.stock_opname_created_time)}`,
        stepCssClass: "has-step-green",
        boxCssClass: "has-color-red",
      }
      const obj2 = {
        title: 'Lab Manager',
        content: item.stock_opname_is_confirmed_by_lab_manager === true ? `Transfer Has been Accepted by Lab Manager` : `Transfer Has not been Accepted By Lab Manager`,
        stepCssClass: item.stock_opname_is_confirmed_by_lab_manager === true ? "has-step-green" : "has-step-red",
      }
      const obj3 = {
        title: 'Administrator',
        content: item.stock_opname_is_confirmed_by_administrator === true ? `Transfer Has been Confirmed By Administrator` : `Transfer Has not been Confirmed by Administrator`,
        stepCssClass: item.stock_opname_is_confirmed_by_administrator === true ? "has-step-green" : "has-step-red",
      }
      this.statusItems = []
      this.statusItems.push(obj1)
      this.statusItems.push(obj2)
      this.statusItems.push(obj3)

      axios
      .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_STOCK_OPNAME_DETAILS}${id}`, { headers })
      .then(response => {
        if (response.data.success === true) {
          this.items = response.data.data
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
        } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data failed',
                icon: 'CheckIcon',
                variant: 'danger',
              },
            })
        }
        })
    })
  },
  print() {
    const userToken = this.$cookies.get('userToken')
const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${userToken}`,
}
    const id = this.stockOpnameId
    axios
    .get(`${process.env.VUE_APP_API_DOWNLOAD_purchase_order}${id}`, { headers })
    .then(response => {
      if (response.data.success === true) {

      } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Download Data failed',
              icon: 'CheckIcon',
              variant: 'danger',
            },
          })
      }
      })
  },
    getOptionLabel(option) {
      return (option && option.label) || ''
    },
    putItem(val) {
      if (this.chosens.length > 0) {
        let same = false
        this.chosens.map(elem => {
              if (elem.value === val.value) {
                same = true
              }
        })
        if (same === false) {
            let item = null
            this.items.map(elem => {
              if (elem.value === val.value) {
                item = { label: elem.label, value: elem.value, qty: 1 }
              }
            })
          this.chosens.push(item)
        }
      } else {
            let item = null
            this.items.map(elem => {
              if (elem.value === val.value) {
                item = { label: elem.label, value: elem.value, qty: 1 }
              }
            })

          this.chosens.push(item)
      }
    },
    applyItem(val) {

    },
    getOptionKey(option) {
      return (option && option.value) || ''
    },
    inputSearch(search) {

    },
    removeRow(val) {
      this.chosens = this.chosens.filter(obj => (obj.value !== val))
    },
    dateFormat(value, format = 'MM/DD/YYYY') {
        return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
  dateSimple(value, format = 'YYYY-MM-DD') {
      let dateRet = ''
      if (value !== null) {
        dateRet = moment.utc(value).tz('Asia/Jakarta').format(format)
      } else { dateRet = null }
      return dateRet
  },
  previous() {
        this.$router.push({ name: 'apps-stock-opname-list' })
  },
  openVoidModal() {
    this.VoidReason = ''
    this.modalVoidShow = true
  },
  voidStockOpname() {
    if (!this.VoidReason) {
      this.$toast({
        component: ToastificationContent,
        props: { title: 'Reason is required', icon: 'AlertTriangleIcon', variant: 'danger' },
      })
      return
    }
    this.submitButtonDisabled = true
    const userToken = this.$cookies.get('userToken')
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    const body = {
      TransactionNumber: this.stockOpnameNumber,
      VoidReason: this.VoidReason,
      time: moment(),
    }
    axios
      .post(`${process.env.VUE_APP_API_URL}transactions/void`, body, { headers })
      .then(response => {
        this.submitButtonDisabled = false
        if (response.data.success === true) {
          this.modalVoidShow = false
          const status = response.data.data && response.data.data.status
          const stored = JSON.parse(localStorage.getItem('StockOpnameDetail'))
          if (status === 'pending') {
            // Finance's request - not voided yet, waiting on FA
            this.stockOpnameVoidStatus = 'pending'
            this.stockOpnameVoidReason = this.VoidReason
            if (stored) {
              stored.stock_opname_void_status = 'pending'
              stored.stock_opname_void_reason = this.VoidReason
            }
          } else {
            // Administrator - voided immediately
            this.stockOpnameIsDeleted = true
            this.stockOpnameDeletedReason = this.VoidReason
            if (stored) {
              stored.stock_opname_is_deleted = true
              stored.stock_opname_deleted_reason = this.VoidReason
            }
          }
          if (stored) {
            localStorage.setItem('StockOpnameDetail', JSON.stringify(stored))
          }
          this.$toast({
            component: ToastificationContent,
            props: { title: response.data.message || 'Void data success', icon: 'CheckIcon', variant: 'success' },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: { title: response.data.message || 'Something went wrong', icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        }
      })
      .catch(() => {
        this.submitButtonDisabled = false
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Void failed', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      })
  },
  // FA-only: approve (actually void) or reject the pending void request from Finance.
  resolveVoid(approve) {
    const userToken = this.$cookies.get('userToken')
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    const body = {
      approve,
      time: moment(),
    }
    axios
      .post(`${process.env.VUE_APP_API_URL}transactions/stock_opname/void/resolve/${this.stockOpnameId}`, body, { headers })
      .then(response => {
        if (response.data.success === true) {
          const status = response.data.data && response.data.data.status
          const stored = JSON.parse(localStorage.getItem('StockOpnameDetail'))
          if (status === 'voided') {
            this.stockOpnameIsDeleted = true
            this.stockOpnameDeletedReason = this.stockOpnameVoidReason
            this.stockOpnameVoidStatus = 'approved'
            if (stored) {
              stored.stock_opname_is_deleted = true
              stored.stock_opname_deleted_reason = this.stockOpnameVoidReason
              stored.stock_opname_void_status = 'approved'
            }
          } else {
            this.stockOpnameVoidStatus = 'rejected'
            if (stored) {
              stored.stock_opname_void_status = 'rejected'
            }
          }
          if (stored) {
            localStorage.setItem('StockOpnameDetail', JSON.stringify(stored))
          }
          this.$toast({
            component: ToastificationContent,
            props: { title: response.data.message, icon: 'CheckIcon', variant: 'success' },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: { title: response.data.message || 'Something went wrong', icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        }
      })
      .catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Something went wrong', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      })
  },
    numberFormat(value) {
      return parseFloat(value).toFixed(2)
    },
  },
}
</script>
